import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './fr.json';
import de from './de.json';
import en from './en.json';

i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, de: { translation: de }, en: { translation: en } },
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
});

// D12 : synchronise l'attribut lang du document avec la langue active
// (lecteurs d'écran, correcteurs, moteurs) — il restait figé sur « fr ».
if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language;
  i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
  });
}

export default i18n;
